import clsx from 'clsx';
import { CSSProperties } from 'react';
import { handleClick, handleKeyPress } from './InformationContainer.handlers';
import useInformationContainerStyles from './InformationContainer.styles';

interface Props {
	active?: boolean;
	canClick?: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	id: string;
	onClick?(): void;
	style?: CSSProperties;
	tabIndex?: number;
}

const InformationContainer: React.FC<React.PropsWithChildren<Props>> = ({
	active = false,
	canClick = false,
	children,
	disabled = false,
	fullWidth,
	id,
	onClick,
	style,
	tabIndex,
}) => {
	const classes = useInformationContainerStyles();

	return (
		<div
			className={clsx(classes.root, {
				[classes.rootFullWidth]: fullWidth,
				[classes.rootHover]: canClick && !active && !disabled,
				[classes.rootDisabled]: disabled,
				[classes.rootDisabledHover]: canClick && disabled,
				[classes.rootActive]: active && !disabled,
			})}
			id={id}
			onClick={handleClick(canClick, onClick)}
			onKeyPress={handleKeyPress(canClick, onClick)}
			role="button"
			style={style}
			tabIndex={tabIndex}
		>
			{children}
		</div>
	);
};

export default InformationContainer;
